import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const AnalyticsScripts = ({ analytics }) => {
  const location = useLocation();

  useEffect(() => {
    // Track page views when route changes
    if (analytics?.googleAnalyticsId && window.gtag) {
      window.gtag('config', analytics.googleAnalyticsId, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, analytics]);

  useEffect(() => {
    // Only inject scripts once on initial mount
    if (!analytics) return;

    // Inject Google Analytics
    if (analytics.googleAnalyticsId && !document.querySelector(`script[src*="${analytics.googleAnalyticsId}"]`)) {
      const gaScript1 = document.createElement('script');
      gaScript1.async = true;
      gaScript1.src = `https://www.googletagmanager.com/gtag/js?id=${analytics.googleAnalyticsId}`;
      document.head.appendChild(gaScript1);

      const gaScript2 = document.createElement('script');
      gaScript2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${analytics.googleAnalyticsId}');
      `;
      document.head.appendChild(gaScript2);
    }

    // Inject Google Tag Manager (Head)
    if (analytics.googleTagManagerId && !document.querySelector(`script[src*="${analytics.googleTagManagerId}"]`)) {
      const gtmScript = document.createElement('script');
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${analytics.googleTagManagerId}');
      `;
      document.head.appendChild(gtmScript);

      // GTM noscript fallback
      const gtmNoScript = document.createElement('noscript');
      gtmNoScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${analytics.googleTagManagerId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.insertBefore(gtmNoScript, document.body.firstChild);
    }

    // Inject custom head code
    if (analytics.customHeadCode) {
      const customHeadDiv = document.createElement('div');
      customHeadDiv.innerHTML = analytics.customHeadCode;
      
      // Append each child element to head
      Array.from(customHeadDiv.children).forEach(child => {
        document.head.appendChild(child.cloneNode(true));
      });
    }

    // Inject custom body code
    if (analytics.customBodyCode) {
      const customBodyDiv = document.createElement('div');
      customBodyDiv.innerHTML = analytics.customBodyCode;
      
      // Insert at the beginning of body
      Array.from(customBodyDiv.children).forEach(child => {
        document.body.insertBefore(child.cloneNode(true), document.body.firstChild);
      });
    }
  }, []); // Only run once on mount

  return null; // This component doesn't render anything
};
